{
  "cc-flywheel-feature-discovery.rovo-awareness-survey.question": [
    {
      "type": 0,
      "value": "To what extent do you agree or disagree with the following statement?"
    }
  ],
  "cc-flywheel-feature-discovery.rovo-awareness-survey.statement": [
    {
      "type": 0,
      "value": "I'm aware of Atlassian Rovo and its functionalities."
    }
  ],
  "confluence-home-rovo-awareness.banner.ask-anything-cta": [
    {
      "type": 0,
      "value": "Ask Rovo"
    }
  ],
  "confluence-home-rovo-awareness.banner.description": [
    {
      "type": 0,
      "value": "Let your AI teammate do the heavy lifting so you can focus on what matters. Just ask."
    }
  ],
  "confluence-home-rovo-awareness.banner.dismiss-banner-cta": [
    {
      "type": 0,
      "value": "Close banner"
    }
  ],
  "confluence-home-rovo-awareness.banner.header": [
    {
      "type": 0,
      "value": "Ask Rovo to get you up to speed, create automations, brainstorm ideas, and more."
    }
  ],
  "confluence-home-rovo-awareness.banner.more-ideas-cta": [
    {
      "type": 0,
      "value": "More ideas"
    }
  ],
  "confluence-home-rovo-awareness.banner.search-bar-image-text": [
    {
      "type": 0,
      "value": "If you Rovo, you know..."
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.audio-description": [
    {
      "type": 0,
      "value": "Rovo′s audio briefings can fill you in on key information from your team.Just hit play and go for a walk."
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.audio-title": [
    {
      "type": 0,
      "value": "Get briefed on the go"
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.carousel-image-alt": [
    {
      "type": 0,
      "value": "New Feature"
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.create-description": [
    {
      "type": 0,
      "value": "You describe, Rovo creates. Pages, live docs, whiteboards, databases — Rovo does it all."
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.create-title": [
    {
      "type": 0,
      "value": "Bye-bye blank page"
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.description": [
    {
      "type": 0,
      "value": "Discover how you can use Rovo to make your life easier."
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.diagram-description": [
    {
      "type": 0,
      "value": "Rovo can draw the diagrams for you that clearly communicate your ideas."
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.diagram-title": [
    {
      "type": 0,
      "value": "Let flow charts flow"
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.lozenge-coming-soon": [
    {
      "type": 0,
      "value": "Coming soon"
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.lozenge-new": [
    {
      "type": 0,
      "value": "New"
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.next-label": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.previous-label": [
    {
      "type": 0,
      "value": "Previous"
    }
  ],
  "confluence-home-rovo-awareness.carousel-modal.title": [
    {
      "type": 0,
      "value": "More ways to Rovo"
    }
  ],
  "post-office.confluence-create-with-rovo-side-nav-nudge.body": [
    {
      "type": 0,
      "value": "With a simple prompt, Rovo can draft a page or whiteboard."
    }
  ],
  "post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action": [
    {
      "type": 0,
      "value": "Show me how"
    }
  ],
  "post-office.confluence-create-with-rovo-side-nav-nudge.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.confluence-create-with-rovo-side-nav-nudge.heading": [
    {
      "type": 0,
      "value": "You describe, Rovo creates"
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-button": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-description": [
    {
      "type": 0,
      "value": "Create charts, diagrams, and other visuals inspired by existing content."
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-header": [
    {
      "type": 0,
      "value": "Transform your content"
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Remix content illustration"
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-new-description": [
    {
      "type": 0,
      "value": "Create charts, diagrams, and other content inspired by existing work."
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-new-header": [
    {
      "type": 0,
      "value": "Create custom visuals"
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-tour-done-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-tour-next-button": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-1-description": [
    {
      "type": 0,
      "value": "Ask Rovo to make adjustments to your remix."
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-1-header": [
    {
      "type": 0,
      "value": "Refine with Rovo"
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-copy-description": [
    {
      "type": 0,
      "value": "Then paste it somewhere else in Confluence to view it later."
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-copy-header": [
    {
      "type": 0,
      "value": "Copy this remix"
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-insert-description": [
    {
      "type": 0,
      "value": "Add your remix directly to this content, or copy and paste it somewhere else."
    }
  ],
  "post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-insert-header": [
    {
      "type": 0,
      "value": "Insert this remix"
    }
  ],
  "post-office.confluence-maui-slides-create-spotlight.spotlight-button": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "post-office.confluence-maui-slides-create-spotlight.spotlight-description": [
    {
      "type": 0,
      "value": "Turn rough ideas and existing content into polished slides in seconds."
    }
  ],
  "post-office.confluence-maui-slides-create-spotlight.spotlight-header": [
    {
      "type": 0,
      "value": "Create stunning presentations"
    }
  ],
  "post-office.confluence-maui-slides-create-spotlight.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Create slides illustration"
    }
  ],
  "post-office.confluence-maui-slides-edit-spotlight.spotlight-button": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "post-office.confluence-maui-slides-edit-spotlight.spotlight-description": [
    {
      "type": 0,
      "value": "Use Rovo to add or remove slides, edit sections, change the tone, and more."
    }
  ],
  "post-office.confluence-maui-slides-edit-spotlight.spotlight-header": [
    {
      "type": 0,
      "value": "Refine slides with Rovo"
    }
  ],
  "post-office.confluence-maui-slides-modal.description": [
    {
      "type": 0,
      "value": "Create polished presentations with Rovo."
    }
  ],
  "post-office.confluence-maui-slides-modal.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.confluence-maui-slides-modal.feature-add-sources": [
    {
      "type": 0,
      "value": "Add sources or links for context"
    }
  ],
  "post-office.confluence-maui-slides-modal.feature-describe-presentation": [
    {
      "type": 0,
      "value": "Start by describing your ideal presentation"
    }
  ],
  "post-office.confluence-maui-slides-modal.feature-refine-slides": [
    {
      "type": 0,
      "value": "Refine your slides with Rovo"
    }
  ],
  "post-office.confluence-maui-slides-modal.got-it": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "post-office.confluence-maui-slides-modal.media-alt": [
    {
      "type": 0,
      "value": "Slides feature illustration"
    }
  ],
  "post-office.confluence-maui-slides-modal.title": [
    {
      "type": 0,
      "value": "Welcome to Slides"
    }
  ],
  "post-office.confluence-maui-slides-modal.try-it-out": [
    {
      "type": 0,
      "value": "Create my own"
    }
  ],
  "post-office.confluence-maui-slides-toolbar-spotlight.spotlight-button": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "post-office.confluence-maui-slides-toolbar-spotlight.spotlight-description": [
    {
      "type": 0,
      "value": "Ask Rovo to rewrite, adjust tone, shorten or lengthen text, or apply other changes."
    }
  ],
  "post-office.confluence-maui-slides-toolbar-spotlight.spotlight-header": [
    {
      "type": 0,
      "value": "Make edits with Rovo"
    }
  ],
  "post-office.confluence-object-sidebar-remix-changeboarding.spotlight-button": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "post-office.confluence-object-sidebar-remix-changeboarding.spotlight-description": [
    {
      "type": 0,
      "value": "Transform content into slides, infographics, whiteboards, and more."
    }
  ],
  "post-office.confluence-object-sidebar-remix-changeboarding.spotlight-header": [
    {
      "type": 0,
      "value": "Remix this content"
    }
  ],
  "post-office.confluence-object-sidebar-remix-changeboarding.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Remix content illustration"
    }
  ]
}